import React from "react"

import CashoutsTable from "./components/tables/CashoutsTable";

export default class Cashouts extends React.Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    return (
      <CashoutsTable
        title={"Cashouts"}
      />
    )
  }

}
